<template>
  <v-btn
    v-if="showerrors"
    fab
    width="27"
    height="27"
    color="primary"
    elevation="0"
    class="btn_tippy vuetify--sacnite"
    :class="clase + (loading ? ' loading' : '')"
    :loading="loading"
    :title="$t('view.commons.errors') || title"
    @click="errors(clave || item)">
    <em class="fas fa-file-excel" />
  </v-btn>
</template>
<script>
export default {
  name: "ButtonErrors"
  , props: {
    clave: {
      default: null
      , type: Number
    }
    , item: {
      default: null
      , type: Object
    }
    , showerrors: {
      default: true
      , type: Boolean
    }
    , loading: {
      default: false
      , type: Boolean
    }
    , clase: {
      default: null
      , type: String
    }
    , title: {
      default: null
      , type: String
    }
  }
  , methods: {
    errors(clave) {
      this.$emit("errors", clave);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/datatable/ButtonErrors.vue